import styled from 'styled-components';

import { BulletChartWrapperTypes } from './BulletChart.types';

export const BulletChartWrapper = styled.div<BulletChartWrapperTypes>`
  width: ${(props): string => `${props.width}px` || '120px'};
  height: ${(props): string => `${props.height}px` || '16px'};
`;
